import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  terms = {
    privacy: '',
    service: '',
  };

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.getTemrs();
  }

  async getTemrs() {
    this.terms = await this.db.doc$(`master/terms`).pipe(first()).toPromise();
  }
}
